import React from "react";
import styled from "styled-components";
import { IconError } from "../../assets/IconError";
const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .text-field {
    width: calc(100% - 2rem);
    padding: var(--fs-textfield) calc(1rem - 1px);
    border-radius: calc(var(--border-radius) / 2);
    border: 1px var(--border-2) solid;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    &.error-text {
      border: 1px var(--secondry-1) solid;
    }
    &.ltr-text {
      direction: ltr;
      text-align: left;
    }
    :focus {
      border: 1px var(--border-3) solid;
    }
  }
  .error {
    display: flex;
    height: 1rem;
    font-size: var(--fs-small);
    .icon {
      text-align: center;
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0 0.2rem 0 0;
    }
  }
  @media screen and (max-width: 1445px) {
    .text-field {
      padding: 0.7rem 1rem;
    }
  }
`;

// dokme chesm baray ramz ha

export const TextInputBig = ({
  style,
  name,
  error,
  value,
  onchange,
  placeHolder,
  required,
  ltr,
}) => {
  let errorComp = "";
  let classes = "text-field";
  if (error.toString()) {
    classes = "text-field error-text";
    errorComp = (
      <div className="error">
        <IconError />
        <div className="text">{error}</div>
      </div>
    );
  }
  if (ltr) {
    classes += " ltr-text";
  }
  return (
    <Styles>
      <textarea
        //style={style} delete shod az styles

        style={style}
        className={classes}
        value={value}
        name={name}
        placeholder={placeHolder}
        onChange={onchange}
        required={required}
        rows={5}
      ></textarea>
      {errorComp}
    </Styles>
  );
};
